import axios from 'axios'

import CONFIG from '../../config'
import {authService, storage} from '.'

const apiUrl: string = (CONFIG.APP.API_URL ? CONFIG.APP.API_URL : '')

const http = axios.create({
  baseURL: apiUrl,
  headers: { 'Content-Type': 'application/json' }
})

const get = async (serv: string, headers: any = {}) => {
  try {
    return await http.get(`${apiUrl}${serv}`, { headers: headers })
  } catch(error: any) {
    respError(error)
  }
}

const getSrv = async (serv: string, headers: any = {}) => {
  try {
    return await http.get(serv, { headers: headers })
  } catch(error: any) {
    respError(error)
  }
}

const post = async (serv: string, data: any, headers: any = {}) => {
  try {
    return await http.post(`${apiUrl}${serv}`, data, { headers: headers })
  } catch(error: any) {
    respError(error)
  }
}

const postSrv = async (serv: string, data: any, headers: any = {}) => {
  try {
    return await http.post(serv, data, { headers: headers })
  } catch(error: any) {
    respError(error)
  }
}

const put = async (serv: string, data: object, headers: any = {}) => {
  try {
    return await http.put(`${apiUrl}${serv}`, data, { headers: headers })
  } catch(error: any) {
    respError(error)
  }
}

const del = async (serv: string, id?: number, headers: any = {}) => {
  try {
    return await http.delete(`${apiUrl}${serv}${id !== undefined ? '/' + id : ''}`, { headers: headers })
  } catch(error: any) {
    respError(error)
  }
}

const respError = (error: any) => {
  const resp: any = (error && error.response ? error.response : {})
  if(resp && resp.status === 401) {
    if (resp.data && resp.data.otherSession && resp.data.otherSession === true) {
      storage.set('otherSession', true)
    }
    sessionExpireRedirect()
    return ''
  }

  const respDef: any = {
    ...resp.data,
      statusCode: resp.status
  }
  throw (resp ? respDef : {})
}

const sessionExpireRedirect = () => {
  const pageRole: string = authService.getUserCurrentPageRole()

  authService.setUserCurrentSessionExpired(true);
  (window as any).location.href = (pageRole === CONFIG.AUTH.ROLES.ADMIN ? CONFIG.ROUTES.ADMIN.HOME : CONFIG.ROUTES.HOME)
}

const api = {
  get,
  getSrv,
  post,
  postSrv,
  put,
  del
}
export default api